"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entry_config = void 0;
exports.findDomainConfig = findDomainConfig;
var jsx_runtime_1 = require("react/jsx-runtime");
var Transparent_Let___sAchieve_FullLogo_Vertical_Light_png_1 = __importDefault(require("../../assets/logos/letsachieve/Transparent_Let\u0442\u0410\u0429sAchieve_FullLogo_Vertical_Light.png"));
var Transparent_Let___sAchieve_FullLogo_Slogan_Vertical_Dark_png_1 = __importDefault(require("../../assets/logos/letsachieve/Transparent_Let\u0442\u0410\u0429sAchieve_FullLogo_Slogan_Vertical_Dark.png"));
var Transparent_Let___sAchieve_FullLogo_Slogan_Vertical_Light_png_1 = __importDefault(require("../../assets/logos/letsachieve/Transparent_Let\u0442\u0410\u0429sAchieve_FullLogo_Slogan_Vertical_Light.png"));
var LetsAchieve_Pattern_jpg_1 = __importDefault(require("../../assets/backgrounds/LetsAchieve_Pattern.jpg"));
exports.entry_config = [
    // Define the domain for the themes.
    {
        domains: ["letsachieve.app"],
        config: {
            slogan: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Be bold,", (0, jsx_runtime_1.jsx)("br", {}), "Have courage,", (0, jsx_runtime_1.jsx)("br", {}), "Let's Achieve"] })),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#0000E0]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#0000E0]",
                },
                link: {
                    text: "text-[#0000E0]",
                },
                radio: {
                    box: "text-[#0000E0]",
                },
            },
            logo: {
                light: Transparent_Let___sAchieve_FullLogo_Slogan_Vertical_Light_png_1.default,
                dark: Transparent_Let___sAchieve_FullLogo_Slogan_Vertical_Dark_png_1.default,
                entry: Transparent_Let___sAchieve_FullLogo_Vertical_Light_png_1.default,
            },
            sideImage: LetsAchieve_Pattern_jpg_1.default,
        },
    },
];
function findDomainConfig() {
    var domain = window.location.host;
    console.log("domain", domain);
    // eg: domain = "console.letstrade.global"
    // eg: c.domains = [ "letstrade.global" ]
    var conf = exports.entry_config.find(function (c) { return c.domains.some(function (d) { return domain.includes(d); }); });
    if (!conf) {
        conf = exports.entry_config[0]; // Default to Let's Trade.
    }
    console.log("conf", conf);
    return conf;
}
